import { render, staticRenderFns } from "./TheEmployee.vue?vue&type=template&id=3c13fad8&scoped=true&"
import script from "./TheEmployee.vue?vue&type=script&lang=js&"
export * from "./TheEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13fad8",
  null
  
)

export default component.exports